import { IScope } from "angular";
import { StateService } from "@uirouter/angularjs";
import { IColoringSetup } from "../models";
import { AccountService } from "@gtmhub/accounts/accounts-service";
import colors from "wwwroot/json/colors.json";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { ProgressColoring } from "../services/progress-coloring";

export interface IColoringScope extends IScope {
  colors: string[];
  newRange: number;
  coloring: IColoringSetup;
  addRange(): void;
  save(): void;
  removeRange(number: number): void;
}

export class ColoringCtrl {
  public static $inject = ["$scope", "AccountService", "$state", "UIErrorHandlingService", "ProgressColoring"];

  constructor(
    private $scope: IColoringScope,
    private accountService: AccountService,
    private $state: StateService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private progressColoring: ProgressColoring
  ) {}

  public stateInit(): void {
    return this.init();
  }

  private init = () => {
    this.$scope.colors = colors.colorScaleAndConfidenceLevelColors;
    this.$scope.addRange = this.addRange;
    this.$scope.save = this.save;
    this.$scope.removeRange = this.removeRange;

    this.$scope.coloring = this.accountService.getAccountSetting("coloring");
  };

  private removeRange = (number: number) => {
    for (let i = 0; i < this.$scope.coloring.ranges.length; i++) {
      if (this.$scope.coloring.ranges[i].lower === number) {
        this.$scope.coloring.ranges.splice(i, 1);
        break;
      }
    }
  };

  private addRange = () => {
    this.$scope.coloring.ranges.push({ lower: this.$scope.newRange, color: "#cccccc" });
  };

  private save = () => {
    this.progressColoring.setColoring(this.$scope.coloring);

    this.accountService.setAccountSetting("coloring", this.$scope.coloring).then(
      () => {
        this.$state.go("^.^");

        setTimeout(() => {
          location.reload();
        }, 100);
      },
      (error) => this.uiErrorHandlingService.handleModal(error)
    );
  };
}
